import { hmsAPI } from '@/api'

export const loginPost = data => hmsAPI.post('/login', data)
export const logout = () => hmsAPI.get('/logout')
export const getToken = () => hmsAPI.get('/me')
